import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import Button from '@mui/material/Button';
import { noPaddingStyle, noPaddingStyle85 } from './styles';
import './Tile.css';

const TileFront = ({
  title,
  subTitle,
  flipEnabled,
  flipTile,
  flipLabel,
  leftInfo,
  rightInfo,
  drilldownFunc,
  drilldownEnabled,
}) => (
  <Card style={noPaddingStyle}>
    <CardContent style={noPaddingStyle}>
      <CardActionArea
        style={noPaddingStyle85}
        onClick={(e) => drilldownFunc(e)}
        disabled={!drilldownEnabled}
      >
        <div className="Tile-header Tile-header-front">
          <div className="Tile-left">
            <Typography>{leftInfo}</Typography>
          </div>
          <div className="Tile-right">
            <Typography>{rightInfo}</Typography>
          </div>
        </div>
        <div className="Tile-content-front">
          <div className="Tile-centered">
            <Typography variant="h5" style={{ fontSize: '3em' }}>
              {title}
            </Typography>
            <Typography>{subTitle}</Typography>
          </div>
        </div>
      </CardActionArea>
      <div className="Tile-footer Tile-footer-front">
        <div className="Tile-left" />
        <div className="Tile-right">
          {flipEnabled && (
            <Button
              color="secondary"
              onClick={(e) => flipTile(e)}
              style={{
                paddingRight: '0px',
                paddingLeft: '0px',
              }}
            >
              {flipLabel}
            </Button>
          )}
        </div>
      </div>
    </CardContent>
  </Card>
);

export default TileFront;

TileFront.defaultProps = {
  flipEnabled: false,
  flipLabel: null,
  drilldownFunc: null,
  drilldownEnabled: false,
};

TileFront.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  flipEnabled: PropTypes.bool,
  leftInfo: PropTypes.string.isRequired,
  rightInfo: PropTypes.string.isRequired,
  flipTile: PropTypes.func.isRequired,
  flipLabel: PropTypes.string,
  drilldownFunc: PropTypes.func,
  drilldownEnabled: PropTypes.bool,
};
